import { useState } from "react";
import { navItems } from "../content";
import { MenuIcon } from "../icons";
import type { Locale } from "../types";
import BrandMark from "./BrandMark";

type SiteHeaderProps = {
  locale: Locale;
  setLocale: (locale: Locale) => void;
};

export default function SiteHeader({ locale, setLocale }: SiteHeaderProps) {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="header-inner">
        <a href="#top" className="brand-link" aria-label={locale === "zh" ? "AgentNexus 首页" : "AgentNexus home"}>
          <BrandMark compact />
        </a>
        <button
          className="mobile-menu-button"
          type="button"
          aria-expanded={open}
          aria-controls="primary-navigation"
          onClick={() => setOpen((value) => !value)}
        >
          <span className="visually-hidden">{locale === "zh" ? "打开导航" : "Open navigation"}</span>
          <MenuIcon />
        </button>
        <nav id="primary-navigation" className={open ? "is-open" : ""} aria-label={locale === "zh" ? "主导航" : "Primary navigation"}>
          {navItems.map((item) => (
            <a key={item.href} href={item.href} onClick={() => setOpen(false)}>
              {item.label[locale]}
            </a>
          ))}
        </nav>
        <div className="language-toggle" aria-label={locale === "zh" ? "语言" : "Language"}>
          <button type="button" className={locale === "zh" ? "active" : ""} onClick={() => setLocale("zh")} aria-pressed={locale === "zh"}>
            中文
          </button>
          <span>/</span>
          <button type="button" className={locale === "en" ? "active" : ""} onClick={() => setLocale("en")} aria-pressed={locale === "en"}>
            EN
          </button>
        </div>
      </div>
    </header>
  );
}
